export default __webpack_public_path__ + "static/media/Ideate_5.47d923f8.jpg";